import { ReactElement, memo } from "react";
import { useSelector } from "react-redux";
import check from "../../assets/images/Check.png";
import useStyles from './styles';
import { AppState } from '../../reducers';

interface IFormProps {
    handleClickAway: any;
    infoEntity: any;
    method: any;
    mode?: string;
}

const Prompt: React.FC<IFormProps> = ({ handleClickAway, infoEntity, method, mode }): ReactElement => {

    const classes = useStyles();

    const { intl } = useSelector((state: AppState) => state.intl);

    return (
        <div className={classes.ctnPrompt}>
            <div className={intl === 'ar' ? classes.txtTitleDelete_ar : classes.txtTitleDelete}>
                {infoEntity?.infoTxt?.txt1}
            </div>
            <div className={classes.ctnImage}>
                <img src={check} alt='' />
            </div>
            <div className={intl === 'ar' ? classes.txtAskDeletionCar_ar : classes.txtAskDeletionCar}>
                {infoEntity?.infoTxt?.txt2}
            </div>
            {infoEntity?.infoTxt?.colorBtnValid !== '#6316DB' ? <div className={intl === 'ar' ? classes.confirmeAskDeletionCar_ar : classes.confirmeAskDeletionCar}>
                {`${infoEntity?.infoTxt?.txt5} "${infoEntity?.data1} ${infoEntity?.data2}" ${infoEntity?.infoTxt?.txt3}`}
            </div> :
                <div className={intl === 'ar' ? classes.confirmeAskDeletionCar_ar : classes.confirmeAskDeletionCar}>
                    {`${infoEntity?.infoTxt?.txt3}`}
                </div>}
            <div className={classes.ctnTable}>
                <table className={classes.btnTable}>
                    <tr>
                        <td>
                            <div data-testid={mode === 'edit' ? "cancel-edit-button" : "cancel-delete-button"} className={intl === 'ar' ? classes.btnCancel_ar : classes.btnCancel} onClick={handleClickAway}>{infoEntity?.infoTxt?.txt4}</div>
                        </td>
                        <td>
                            <div data-testid={mode === 'edit' ? "confirm-edit-button" : "confirm-delete-button"} className={intl === 'ar' ? classes.btnApply_ar : classes.btnApply} style={{ background: `${infoEntity?.infoTxt?.colorBtnValid}` }} onClick={() => method()}>{infoEntity?.infoTxt?.txt5}</div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    )

}

export default memo(Prompt);
